const endpointBase = process.env.REACT_APP_HOST_API_KEY;
const isProduction = process.env.REACT_APP_PRODUCTION == 'true';

// export const isOX =
//     !isProduction||
//     window.location.hostname === 'ox-crm-admin.gen-x.dev' ||
//     window.location.hostname === 'ox-crm-client.gen-x.dev';
export const isDev =
    window.location.hostname == 'localhost' ||
    window.location.hostname == 'bull-crm-admin.gen-x.dev' ||
    window.location.hostname == 'bull-crm-client.gen-x.dev' ||
    window.location.hostname == 'bull-crm-sale.gen-x.dev' ||
    window.location.hostname == 'ox-crm-sale.gen-x.dev' ||
    window.location.hostname == 'ox-crm-client.gen-x.dev' ||
    window.location.hostname == 'ox-crm-admin.gen-x.dev'
// process.env.REACT_APP_IS_DEV;

// import LogoIcon from 'assets/images/OXLogo3.jpg';
import BullKingLogoShortIcon from 'assets/images/Logo-short.png';
import BullKingLogoLongIcon from 'assets/images/Logo-long2.png';
import FoxIcon from 'assets/images/Fox.jpg';
import FoxLongIcon from 'assets/images/FoxLong.jpg';
import LogoIcon from 'assets/images/newFoxLong.jpg';
import SmallIcon from 'assets/images/newFoxSmall.jpg';

const appConfig = {
    name: 'Finance 1',
    displayName: 'Finance 1',
    ico: isDev ? 'favicon.ico' : 'favicon.ico',
    logo: isDev ? LogoIcon : LogoIcon,
    logoShort: isDev ? SmallIcon : SmallIcon,
    apiEndpoint: `${endpointBase}/client/v1`,
    adminApiEndpoint: `${endpointBase}/admin/v1`,
    saleApiEndpoint: `${endpointBase}/sale/v1`,
    authApiEndpoint: `${endpointBase}/client/auth/v1`,
    adminAuthApiEndpoint: `${endpointBase}/admin/auth/v1`,
    explorerApiEndpoint: `${endpointBase}/explorer/v1`,

    storePrefix: process.env.REACT_APP_STORE_PREFIX,
    appPermissionControl: process.env.REACT_APP_PERMISSION_CONTROL
        ? process.env.REACT_APP_PERMISSION_CONTROL.split(',')
        : ['USER', 'ADMIN', 'SALE'],
};
export default appConfig;
